import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModuleFE_Toaster, ToastBuilder } from '../../component-modules/ModuleFE_Toaster.js';
import { TS_Toast } from '../../components/TS_Toaster/index.js';
import { ATS_Frontend } from '../../components/TS_AppTools/index.js';
import { LL_V_L } from '../../components/Layouts/index.js';
import { Minute } from '@nu-art/ts-common';
import { ComponentSync } from '../../core/ComponentSync.js';
export class ATS_Toaster extends ComponentSync {
    static screen = { name: `Toaster`, group: ATS_Frontend, renderer: this };
    static defaultProps = {
        modules: [],
        pageTitle: () => this.screen.name
    };
    deriveStateFromProps(nextProps, state = {}) {
        return state;
    }
    constructor(p) {
        super(p);
        // @ts-ignore
    }
    showAppToasterSuccessExample = () => {
        ModuleFE_Toaster.toastSuccess('Simple success message');
    };
    showToastForVeryLongTime = () => {
        ModuleFE_Toaster.toastSuccess('Simple success message', 6 * Minute);
    };
    showAppToasterErrorExample = () => {
        ModuleFE_Toaster.toastError('Simple error message');
    };
    showAppToasterInfoExample = () => {
        ModuleFE_Toaster.toastInfo('Simple info message');
    };
    showAppToasterCustomInfoExample = () => {
        ModuleFE_Toaster.toastInfo('Custom info message closes in 3 sec', 3000);
    };
    showAppToasterCustomErrorExample = () => {
        ModuleFE_Toaster.toastError('Custom Error message closes in 8 sec', 8000);
    };
    showAppToasterCustomSuccessExample = () => {
        new ToastBuilder().setContent(TS_Toast('is a very nice!', 'success')).show();
    };
    showAppToasterLiveDocsExample = () => {
        new ToastBuilder().setContent(TS_Toast('you spin me right \'round, baby, right \'round', 'success')).show();
    };
    render() {
        return _jsxs(_Fragment, { children: [_jsxs(LL_V_L, { children: [_jsx("button", { style: { marginRight: 8 }, onClick: this.showAppToasterSuccessExample, children: "Toaster Default Success Example" }), _jsx("button", { style: { marginRight: 8 }, onClick: this.showAppToasterErrorExample, children: "Toaster Default Failure Example" }), _jsx("button", { style: { marginRight: 8 }, onClick: this.showAppToasterInfoExample, children: "Toaster Default Info Example" }), _jsx("button", { style: { marginRight: 8 }, onClick: this.showAppToasterLiveDocsExample, children: "Toaster Default Live Docs Example" })] }), _jsx("hr", {}), _jsxs(LL_V_L, { children: [_jsx("button", { style: { marginRight: 8 }, onClick: this.showToastForVeryLongTime, children: "Toaster for ever" }), _jsx("button", { style: { marginRight: 8 }, onClick: this.showAppToasterCustomSuccessExample, children: "Toaster Custom Success Example" }), _jsx("button", { style: { marginRight: 8 }, onClick: this.showAppToasterCustomErrorExample, children: "Toaster Custom Failure Example" }), _jsx("button", { style: { marginRight: 8 }, onClick: this.showAppToasterCustomInfoExample, children: "Toaster Custom Info Example" })] })] });
    }
}
//# sourceMappingURL=ATS_Toaster.js.map